export class Classifications {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "dataClassesDetails",
            "baseName": "dataClassesDetails",
            "type": "DataClassesDetails",
            "format": ""
        },
        {
            "name": "environmentDetails",
            "baseName": "environmentDetails",
            "type": "EnvironmentDetails",
            "format": ""
        },
        {
            "name": "networkClassificationDetails",
            "baseName": "networkClassificationDetails",
            "type": "NetworkClassificationDetails",
            "format": ""
        },
        {
            "name": "appsDetails",
            "baseName": "appsDetails",
            "type": "AppsDetails",
            "format": ""
        },
        {
            "name": "sensitivityLabelsDetails",
            "baseName": "sensitivityLabelsDetails",
            "type": "SensitivityLabelsDetails",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return Classifications.attributeTypeMap;
    }
    constructor() {
    }
}
